import { Component, OnInit } from '@angular/core';
import { ScreenType } from '@fgb/portal-component-library/src/lib/directives';

@Component({
  selector: 'fgb-training-zone-page',
  templateUrl: './training-zone-page.component.html',
  styleUrls: ['./training-zone-page.component.scss'],
})
export class TrainingZonePageComponent implements OnInit {
  screenSize = ScreenType;
  constructor() {}

  ngOnInit() {}
}
